import { type TestIds, createContext } from '../../../utils/index.ts'

export type PageHeaderSize = 'sm' | 'md' | 'lg'

export type UsePageHeaderProps = TestIds & {
  size?: PageHeaderSize
}

export function usePageHeader(props: UsePageHeaderProps) {
  const { dataTestId, dataTrackingId, size = 'md' } = props

  return {
    dataTestId,
    dataTrackingId,
    size,
  }
}

export const [PageHeaderProvider, usePageHeaderContext] = createContext<
  ReturnType<typeof usePageHeader>
>({
  name: 'PageHeaderContext',
})
